export const DWOLLA_ACTION_TYPES = {
   GET_USER_DWOLLA_INFO: 'GET_USER_DWOLLA_INFO',
   GET_USER_DWOLLA_INFO_DONE: 'GET_USER_DWOLLA_INFO_DONE',
};

export const getUsersDwollaInfoAction = (req) => ({
   type: DWOLLA_ACTION_TYPES.GET_USER_DWOLLA_INFO,
   payload: req,
});

export const getUsersDwollaInfoActionDone = (req) => ({
   type: DWOLLA_ACTION_TYPES.GET_USER_DWOLLA_INFO_DONE,
   payload: req,
});


export default {
   DWOLLA_ACTION_TYPES,
   getUsersDwollaInfoAction,
   getUsersDwollaInfoActionDone
} 